import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appDecimalQuantityValidator]',
    standalone: false
})
export class DecimalQuantityValidatorDirective {

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: InputEvent) {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;

    value = value.replace(/[^0-9,.]/g, '');
    
    const internalValue = value.replace(/,/g, '.');
    const firstSeparatorIndex = internalValue.indexOf('.');
    let finalValueToDisplay = internalValue;

    if (firstSeparatorIndex !== -1) {
      const integerPart = internalValue.substring(0, firstSeparatorIndex);
      const separator = '.'; 
      let decimalPart = internalValue.substring(firstSeparatorIndex + 1);

      decimalPart = decimalPart.replace(/[.]/g, ''); 

      if (decimalPart.length > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }

      finalValueToDisplay = integerPart + separator + decimalPart;
    }

    if (finalValueToDisplay !== internalValue) {
      input.value = finalValueToDisplay.replace(/\./g, (firstSeparatorIndex !== -1 && value[firstSeparatorIndex] === ',') ? ',' : '.');
      this.control.control?.setValue(finalValueToDisplay, { emitEvent: false });
    }
    
    else if (internalValue !== input.value) {
      input.value = internalValue;
      this.control.control?.setValue(internalValue, { emitEvent: false });
    }
  }
}